import { render } from "./BpmOgpoSummaryStep.vue?vue&type=template&id=2205e28d"
import script from "./BpmOgpoSummaryStep.vue?vue&type=script&lang=js"
export * from "./BpmOgpoSummaryStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__